@if(settings.Visible)
{
<mat-form-field appearance="outline">
  <mat-label>{{ 'turbo.core.forms.field.' + settings.FieldId | translate : settings.Label}}</mat-label>
  <input [id]="settings.FieldId"
         autocomplete="off"
         matInput
         [required]="settings.Required"
         [formControl]="control"
         [placeholder]="settings.Placeholder"
         (blur)="onBlur()"
         (focus)="onFocus()">
  @if(control.hasError('required')) { <mat-error>{{ errors?.required }}</mat-error> }
  @if(control.hasError('minlength')) { <mat-error>{{ errors?.minLength }}</mat-error> }
  @if(control.hasError('maxlength')) { <mat-error>{{ errors?.minLength }}</mat-error> }
  @if(control.hasError('pattern')) { <mat-error>{{ errors?.pattern }}</mat-error> }
</mat-form-field>

}
